import styled from 'styled-components';

export default styled.div`
background-color: rgba(255, 255, 255, 0.9);
box-shadow: 0 1px 5px rgba(0,0,0,0.65);
border-radius: 4px;
`